import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ScribeLink from './ScribeLink';

import { isExternalUrl } from './ScribeLinkUtils';

export class GraphicBannerWithoutAnalyticsComponent extends PureComponent {
  static propTypes = {
    betaFeatures: PropTypes.arrayOf(PropTypes.string).isRequired,
    classNames: PropTypes.string,
    imageAlt: PropTypes.string,
    imageSrc: PropTypes.string,
    onClick: PropTypes.func,
    showOnMobile: PropTypes.bool,
    url: PropTypes.string,
    // in Scribe there are also two other content types - GRAPHIC_BANNER_CSS_SUFFIX, GRAPHIC_BANNER_BACKGROUND_COLOR,
    // but these are never used, so it makes not point to migrate these to Raven
  };

  renderImage() {
    const { imageSrc, imageAlt } = this.props;

    return <img src={imageSrc} alt={imageAlt} />;
  }

  renderBannerContent() {
    const { url, onClick } = this.props;

    const image = this.renderImage();

    if (!url) {
      return image;
    }

    const target = isExternalUrl(url) ? { target: '_blank', rel: 'noopener noreferrer' } : null;

    return (
      <ScribeLink to={url} {...target} onClick={onClick}>
        {image}
      </ScribeLink>
    );
  }

  render() {
    const {
      betaFeatures,
      classNames,
      imageSrc,
      showOnMobile,
    } = this.props;

    if (!imageSrc) {
      return null;
    }

    const shouldShowOnMobile = (
      betaFeatures.includes('GRAPHIC_BANNERS_ON_MOBILE_FORCE')
      || (
        showOnMobile
        && betaFeatures.includes('GRAPHIC_BANNERS_ON_MOBILE')
      )
    );

    const className = classNames || `supplierBanner supplierBanner2b ${shouldShowOnMobile ? '' : 'show-for-xlarge'}`;

    return (
      <div className={className}>
        <div className="supFund">
          {this.renderBannerContent()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    betaFeatures: state.user.betaFeatures,
  })
)(GraphicBannerWithoutAnalyticsComponent);
